import { render, staticRenderFns } from "./SidebarBoxHighlight.vue?vue&type=template&id=d38041be&scoped=true&"
import script from "./SidebarBoxHighlight.vue?vue&type=script&lang=js&"
export * from "./SidebarBoxHighlight.vue?vue&type=script&lang=js&"
import style0 from "./SidebarBoxHighlight.vue?vue&type=style&index=0&id=d38041be&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d38041be",
  null
  
)

export default component.exports